import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";

import Tag from "@components/v1/labels/Tag";
import styles from "@components/v1/labels/Tag.module.css";
import BodyCopy from "@components/v1/typography/BodyCopy";
import { imageUrl } from "@utils/imageUtils";

const GatherTag = () => {
  const intl = useIntl();
  return (
    <Tag color="primary-500">
      <IonGrid className="ion-no-padding">
        <IonRow className="ion-align-items-center">
          <IonCol size="auto">
            <BodyCopy bold color="white">
              <FormattedMessage id="pages.article.hostedBy" />
            </BodyCopy>
          </IonCol>
          <IonCol>
            <img
              alt={intl.formatMessage({ id: "accessibility.altTags.gather" })}
              className={styles.gatherImage}
              src={imageUrl("gather")}
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </Tag>
  );
};

export default GatherTag;
